module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal-process/modal-process.component.css
// module id = ./src/app/shared/components/modal-process/modal-process.component.css
// module chunks = main